export enum InvestigationPlanLogAction {
	ViolationsFilled = 1,
	QuestionAdded = 2,
	QuestionEdited = 3,
	QuestionDeleted = 4,
	DocumentDisclosed = 5,
	DocumentWithheld = 6,
	QuestionsSent = 7,
	QuestionsAddedToCurrent = 8,
	SessionStarted = 9,
	AttendanceSaved = 10,
	SessionRescheduled = 11,
	SessionCancelled = 12,
	SessionEnded = 13,
	AnswerRecorded = 14,
	MinutesApproved = 15,
	MinutesAttested = 16,
	SignedMinutesUploaded = 17,
	RespondentJoined = 18,
	SessionAttachmentAdded = 19,
	MinutesTextChanged = 20,
	RespondentRequestReceived = 21,
	RespondentRequestDecided = 22,
	NonResponseDecided = 23,
	AnswerEdited = 24,
	SabrQuestionsSuggested = 25,
	SabrQuestionsApproved = 26,
	SabrAnswersAnalyzed = 28,
	SabrNewIssueDecided = 29,
}
